import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { localizePath } from "@/lib/localePath";
import { AuroraWordmark } from "./AuroraHeart";
import { StoreBadgeGroup } from "./StoreBadges";

const GROUPS = [
  {
    titleKey: "groupProduct",
    links: [
      { to: "/features", k: "linkFeatures" },
      { to: "/faith", k: "linkFaith" },
      { to: "/best-ai-couples-apps-2026", k: "linkCompare" },
      { to: "/roadmap", k: "linkRoadmap" },
      { to: "/story", k: "linkStory" },
    ],
  },
  {
    titleKey: "groupForYou",
    links: [
      { to: "/christian", k: "linkChristian" },
      { to: "/for-men", k: "linkMen" },
      { to: "/counseling-vs-divorce", k: "linkCounseling" },
      { to: "/knowledge", k: "linkKnowledge" },
    ],
  },
  {
    titleKey: "groupTrust",
    links: [
      { to: "/privacy", k: "linkPrivacy" },
      { to: "/privacy-vs-llm", k: "linkPrivacyLlm" },
      { to: "/changelog", k: "linkChangelog" },
      { to: "/faq", k: "linkFaq" },
      { to: "/support", k: "linkSupport" },
    ],
  },
];

export const Footer = () => {
  const { t, i18n } = useTranslation(["site", "landing"]);
  const tf = (k) => t(`site:footer.${k}`);
  const L = (to) => localizePath(to, i18n.language);
  return (
    <footer
      className="relative mt-32 border-t border-white/5 overflow-hidden"
      style={{ background: "#0A0420" }}
      data-testid="site-footer"
    >
      <div
        className="absolute inset-0 pointer-events-none opacity-50"
        style={{
          background:
            "radial-gradient(ellipse 800px 300px at 50% 0%, rgba(243,195,90,0.12), transparent 70%)",
        }}
      />
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8 py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <AuroraWordmark />
            <p className="mt-5 text-white/65 font-light max-w-md leading-relaxed">
              {tf("tagline")} {tf("taglineSuffix")}
            </p>
            <div className="mt-7">
              <StoreBadgeGroup
                appleTestId="footer-download-apple"
                googleTestId="footer-download-google"
                startTestId="footer-start-free"
              />
            </div>
          </div>
          <div className="lg:col-span-7 grid sm:grid-cols-3 gap-8">
            {GROUPS.map((g) => (
              <div key={g.titleKey}>
                <p className="eyebrow mb-4">{tf(g.titleKey)}</p>
                <ul className="space-y-3">
                  {g.links.map((l) => (
                    <li key={l.to}>
                      <Link
                        to={L(l.to)}
                        className="text-white/70 hover:text-white text-[0.95rem] transition"
                        data-testid={`footer-link-${l.k}`}
                      >
                        {tf(l.k)}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-wrap items-center justify-between gap-4 text-[0.85rem] text-white/45">
          <p>{tf("copyright")}</p>
          <p className="font-light italic font-serif text-white/55">{tf("italic")}</p>
        </div>

        <div className="relative mt-16 -mb-8 select-none pointer-events-none">
          <p
            className="font-serif text-[14vw] leading-none tracking-tight text-transparent text-center"
            style={{
              WebkitTextStroke: "1px rgba(255,255,255,0.06)",
            }}
          >
            withAurora
          </p>
        </div>
      </div>
    </footer>
  );
};
